import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { StudentService } from 'src/app/student/services/student.service';

@Component({
  selector: 'app-language-popup',
  templateUrl: './language-popup.component.html',
  styleUrls: ['./language-popup.component.scss']
})
export class LanguagePopupComponent implements OnInit {
  isLargeDevice:boolean;
  isSmallDevice:boolean;
  // languages = ['bn', 'en', 'gu', 'hi', 'kn', 'mr', 'ta', 'te', 'ur', 'or', 'ml'];
  selectedLanguage: string;

  selectLanguage(language: string) {
    this.selectedLanguage = language;
  }
  languages = ['Bengali', 'Gujarati', 'Hindi','Kannada','Malyalam','Marathi','Odia','Tamil','Telgu','Urdu']; // Add more languages as needed


  

  constructor(public dialog: MatDialogRef<LanguagePopupComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,private _router: Router, 
    private _authService: AuthService,
    private studentService:StudentService,
    private _snackBar:MatSnackBar,
    private spinner:NgxSpinnerService, 
    private breakpointObserver:BreakpointObserver){
  }


  ngOnInit() {
    this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.XSmall])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isSmallDevice = true;
        this.isLargeDevice = false;
      }
    });
    this.breakpointObserver
    .observe([Breakpoints.Tablet])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isSmallDevice = true;
        this.isLargeDevice = false;
      }
    });
    this.breakpointObserver
    .observe([Breakpoints.Large, Breakpoints.XLarge])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isLargeDevice = true;
        this.isSmallDevice = false;
      }
    });
    
  }

  // onConfirm(){
  //   this.spinner.show();
  //   console.log('this.feedbacktext-----------', this.feedbacktext,this.sliderValue)
  //   //this._router.navigate(['/assessment']);
    
  //   let Obj = {      
  //     uuid: sessionStorage.getItem('userSub'),
  //     rating: this.sliderValue,
  //     feedback: this.feedbacktext
  //   }
  //   this.studentService.saveFeedBack(Obj,this.entityId).subscribe(
  //     data => {
  //       this._snackBar.open('Feedback successfully submitted', '', {
  //         duration: 3 * 1000,
  //         verticalPosition: 'bottom',
  //         panelClass: ['success-snackbar']
  //       });       
  //        this.dialog.close();
  //       this.spinner.hide();
  //       console.log("response",data);
  //     },
  //     error => {
  //       this.spinner.hide();
  //       console.log("error",error);
  //     }
  //   )
   
  // }

  closeDialog(): void {
    // this._authService.assessmentHighlight = true;
    // this.studentService.highlightLeftMenu('/assessment','child')
    this.dialog.close();
  }
}



